import { FC } from 'react';
import { useSelector } from 'react-redux';

import { SectionComponentInterface } from 'types/componentTypes';
import { HelpCenter } from 'components/Sections/ContactUsHelpCenter';
import { Block } from 'src/__generated__/graphqlTypes';
import { Store } from 'app-redux/types/storeTypes';
import { setItemInObjectBySlug } from 'lib/sharedMethods.service';
import { HelpCenterContainerSlug as Slug } from 'components/Sections/ContactUsHelpCenter/declarations';

const helpCenterSlugs = {
  'help-center-title': Slug.TITLE,
  'general-info': Slug.GENERAL_INFO,
  'help-charge-info': Slug.CHARGE_INFO,
};

const HelpCenterContainer: FC<SectionComponentInterface> = ({
  blocks,
  bgColor,
}) => {
  const {
    mobileViewMaxWidth,
  } = useSelector((store: Store) => store.server.app.scssVariables);

  if (!blocks?.length) {
    return null;
  }

  const reducer = setItemInObjectBySlug(helpCenterSlugs);
  const {
    title,
    generalInfo,
    chargeInfo,
  } = blocks.reduce(reducer, {} as Record<Slug, Block>);

  if (!title || !generalInfo) {
    return null;
  }

  return (
    <HelpCenter
      title={title}
      generalInfo={generalInfo}
      chargeInfo={chargeInfo}
      bgColor={bgColor}
      isMobileViewWidth={false}
      mobileViewMaxWidth={mobileViewMaxWidth}
    />
  );
};

export default HelpCenterContainer;
